<!-- 现货快搜-网销商品 -->
<template>
  <div id="SIGoodsSearch" class="business-content-main">
    <div class="scroll-view">
      <div class="head">
        <div class="bread-nav">
          <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
          <div class="search-ctn-left">
            <div class="search-name">汽配编码</div>
            <el-input
              class="search-item"
              size="small"
              v-model.trim="searchData.apCode"
              v-filter-special-char="searchData.apCode"
              placeholder="请输入汽配编码"
            ></el-input>
            <div class="search-name">汽配名称</div>
            <el-input
              class="search-item"
              size="small"
              v-model.trim="searchData.name"
              v-filter-special-char="searchData.name"
              placeholder="请输入汽配名称"
            ></el-input>
            <div class="search-name">适用车型</div>
            <el-input
              class="search-item"
              size="small"
              v-model.trim="searchData.autoSerise"
              v-filter-special-char="searchData.autoSerise"
              placeholder="请输入车型模糊查询"
            ></el-input>
            <!-- <div class="search-name">交货时间</div>
            <el-select
              class="search-item"
              size="small"
              v-model="searchData.deliveryConfigId"
              style="width:100px"
            >
              <el-option
                v-for="item in deliveryTimes"
                :key="item.TKey"
                :label="item.TValue"
                :value="item.TKey"
              ></el-option>
            </el-select>
            <div class="search-name">地址</div>
            <div>
              <el-select
                class="search-item"
                size="small"
                v-model="searchData.province"
                placeholder="不限"
                @change="provinceChange($event)"
                filterable
                clearable
                style="width:100px"
              >
                <el-option
                  v-for="(value1, key1, index) in provinceData"
                  :key="index"
                  :label="key1"
                  :value="key1"
                ></el-option>
              </el-select>
              <el-select
                class="search-item"
                size="small ml-5"
                v-model="searchData.city"
                placeholder="不限"
                @change="cityChange"
                filterable
                clearable
                style="width:100px"
              >
                <el-option
                  v-for="(value2, key2, index) in cityData"
                  :key="index"
                  :label="key2"
                  :value="key2"
                ></el-option>
              </el-select>
              <el-select
                class="search-item"
                size="small ml-5"
                v-model="searchData.district"
                placeholder="不限"
                filterable
                clearable
                style="width:100px"
              >
                <el-option v-for="(item, index) in areaData" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </div> -->
            <div class="search-item" style="width: auto;margin-left: 15px;">
              <el-button
                size="small"
                type="primary"
                 @click="$refs.carTypeSelector.show()"
                title="点击选择"
                style="background-color: #F5F7FA;color: #909399;border: 1px solid #DCDFE6;font-size:14px;padding: 8px 15px;"
              >精准车型</el-button>
              <el-tag
                :key="tag"
                v-for="tag in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
                style="font-size:14px;background-color: #FFF;"
              >{{tag}}</el-tag>
            </div>
            <el-button
              size="small"
              icon="el-icon-search"
              class="search-btn btn-primary"
              @click="handleSearch"
            >查询</el-button>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="search-btn btn-primary"
              @click="resetSearch"
            >重置</el-button>
          </div>
        </div>
      </div>
      <div class="qp-ctn" v-if="tableDataLength > 0">
        <el-card class="box-card qp-item" v-for="item in tableData" :key="item.Id">
          <div @click="gotoDetails(item.Id)">
            <div class="qp-cover">
              <img
                :src="downloadUrl + item.MainImg + '?imageView2/2/w/200'"
                alt=""
                :onerror="defaultImg"
              >
            </div>
            <div class="qp-msg">
              <p style="color:red;font-size:18px;">￥{{ item.SellPrice }}</p>
              <p
                class="title"
                :title="item.GoodsName"
              >{{item.GoodsName.length>20?item.GoodsName.substring(0,17)+'...':item.GoodsName}}</p>
              <p style="color:red;">库存量:{{ item.ShareCount }}</p>
              <p
                :title="item.APCode"
              >{{item.APCode.length>20?item.APCode.substring(0,17)+'...':item.APCode}}</p>
              <p class="ops-ctn">
                <el-button
                  size="mini"
                  @click.stop="askShareGoods(item)"
                  v-if="permission.ask"
                  type="primary"
                  plain
                >联系客服</el-button>
                <el-button
                  size="mini"
                  @click.stop="gotoOrderInfo(item)"
                  class="btn-primary"
                  v-if="permission.buy"
                >立即购买</el-button>
              </p>
            </div>
          </div>
        </el-card>
      </div>
      <div v-else class="no-data">暂无对应的搜索结果</div>
      <el-backtop target=".scroll-view" :bottom="100" :visibility-height="250"></el-backtop>
    <autoSeries ref="carTypeSelector" @chooseResult="chooseResult" />
    </div>
  </div>
</template>
<script>
import autoSeries from "@/components/common/chooseAutoSeries.vue";
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: { breadcrumb,autoSeries },
  data() {
    let curr_user = this.$util.getLocalStorage("userMsg");
    return {
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
      downloadUrl: this.$util.QN_URL_BASE,
      curr_user: curr_user,
      searchData: {
        entpId: curr_user.EntpId,
        province: "",
        city: "",
        district: "",
        apCode: "",
        name: "",
        autoSerise: "",
        sId:"",
        deliveryConfigId: "-1",
        page: 1,
        limit: 10
      },
      noMore: false,
      provinceData: {}, // 省级
      cityData: {}, // 市
      areaData: [], // 区
      address: {},
      tableData: [],
      tableDataLength: 0,
      permission: {},
      deliveryTimes: [{ TKey: "-1", TValue: "不限" }], //交货时间
      scrollY:0,
      dynamicTags:[]
    };
  },
  beforeRouteLeave(to, from, next) {
    let scrollElement = document.querySelector(".scroll-view");
    scrollElement.removeEventListener("scroll", this.handleScroll, false);
    this.scrollY = document.querySelector('.scroll-view').scrollTop
    next();
  },
  activated() {
    let fullPath = this.$route.fullPath;
    document.onkeydown = event => {
        let isDialog =document.querySelector(".v-modal");
        let layui=document.querySelectorAll(".layui-layer");
        if(fullPath == this.$route.fullPath&&!isDialog&&layui.length<=1){ 
            if (event && event.keyCode == 13) {
            this.handleSearch();
            }
        }
    };
    document.querySelector('.scroll-view').scrollTop = this.scrollY
    let scrollElement = document.querySelector(".scroll-view");
    scrollElement.addEventListener("scroll", this.handleScroll, false);
    //搜索车架号页面传过来的参数
    let AutoSerieData = this.$util.getLocalStorage("AutoSerieData");
    if (AutoSerieData) {
      this.searchData.autoSerise = AutoSerieData.AutoSerieName; //这里是用车型名称匹配的
      this.searchData.sId = AutoSerieData.AutoSerieId;
         this.dynamicTags = [
          `${AutoSerieData.Brand} | ${AutoSerieData.AutoSerieName} | ${AutoSerieData.Emission} | ${AutoSerieData.ProducedYear}`,
        ];
      this.$util.clearLocalStorage("AutoSerieData"); //用完即删
      this.calculateLimit();
    }
  },
  mounted() {
    this.permission = this.$util.getPermission("shareInventoryGoodsSearch");
    // eslint-disable-next-line no-undef
    this.provinceData = Region; // 这个是在pubilc/index.html 里面引入的

    this.getDeliveryTimes();
    this.calculateLimit();
  },
  methods: {
    //计算每页获取数据的最大值并且查询数据
    calculateLimit() {
      let maxWidth = document.querySelector(".scroll-view")
        .clientWidth;
      let flowRow =2;
      let flowColumn = Math.floor(maxWidth / 220); //每一页的列数
      this.searchData.limit = flowColumn * flowRow; //当前界面能容纳的item数

      this.getTableData();
    },
    handleScroll() {
      //没有数据，有弹窗打开时return
      if (this.tableData.length == 0) return;
      let scrollTop = document.querySelector(".scroll-view").scrollTop; //滚动条顶部的位置
      let scrollHeight = document.querySelector(".scroll-view")
        .scrollHeight; //滚动条高度
      let windowHeight = document.querySelector(".scroll-view")
        .clientHeight; //可视区的高度
      if (scrollTop + windowHeight >= scrollHeight) {
        if (!this.noMore) {
          this.searchData.page += 1;
          this.getTableData();
        } else {
          this.$util.warningMsg("没有更多数据了");
        }
      }
    },
    provinceChange(val) {
      this.cityData = this.provinceData[val];
      this.searchData.city = "";
      this.searchData.district = "";
      this.areaData = [];
    },
    cityChange(val) {
      this.areaData = this.cityData[val];
      this.searchData.district = "";
      // this.searchData.district = this.areaData[0];
    },
    //获取企业默认地址
    getDefaultAddress() {
      return this.$util
        .axiosGet({
          url:
            "/api/EntpInfoManagement/GetEntpDefaultAddress?entpId=" +
            this.curr_user.EntpId,
          hideLoading: true
        })
        .then(res => {
          if (res.data) {
            let addData = res.data.data;
            this.searchData.province = addData.Province;
            this.searchData.city = addData.City;
            this.searchData.district = addData.District;

            this.cityData = this.provinceData[addData.Province];
            this.areaData = this.cityData[addData.City];
          }
        })
        .catch(err => {});
    },

    //获取交货时间
    getDeliveryTimes() {
      this.$util
        .axiosGet({
          url: "/api/ShareInventory/GetDeliveryTimes",
          hideLoading: true
        })
        .then(res => {
          if (res.data) {
            this.deliveryTimes = this.deliveryTimes.concat(res.data);
          }
        })
        .catch(err => {});
    },
    // 获取数据
    getTableData() {
      this.$util
        .axiosGet({
          url: "/api/ShareInventory/SearchShareInventory",
          data: this.searchData
        })
        .then(res => {
          if (res.data) {
            this.tableData = this.tableData.concat(res.data);
            this.tableDataLength = res.count;
            this.noMore = this.tableData.length == this.tableDataLength;
          }
        })
        .catch(err => {});
    },
    handleSearch() {
      this.searchData.page = 1;
      this.tableData = [];
      document.querySelector(".scroll-view").scrollTop = 0; //滚动条移回顶部
      this.getTableData();
    },
    // 重置表单
    resetSearch() {
      this.searchData.entpId = this.curr_user.EntpId;
      this.searchData.province = "";
      this.searchData.city = "";
      this.searchData.district = "";
      this.searchData.apCode = "";
      this.searchData.name = "";
      this.searchData.autoSerise = "";
      this.searchData.deliveryConfigId = "";
      this.searchData.page = 1;
      this.searchData.sId = "";
    },
    // 询问共享网销商品
    askShareGoods(item) {
      if (this.$store.state.connectState != 2) {
        this.$util.warningMsg("请先连接到客服再进行询问");
        return;
      }
      this.$store.commit("updateAskShareGoods", item);
      this.$util.successMsg("已向客服发送该商品");
    },
    // 跳转结算页面
    gotoOrderInfo(item) {
      this.$router.push(
        `/shareInventory/siOrderConfirm?goodsId=` +
          item.Id +
          "&buyQuantity=" +
          1
      );
    },
    // 跳转到汽配详情
    gotoDetails(id) {
      this.$router.push(`/shareInventory/goodsDetails?id=${id}`);
    },
    handleClose(tag) {
      this.searchData.sId = "";
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
     // 选择车型返回结果
    chooseResult(arr) {
      this.searchData.sId = arr.SId;
      this.dynamicTags = [
        `${arr.Cn} | ${arr.AutoSerieName} | ${arr.Emission} | ${arr.ProducedYear} | ${arr.SaleModel}`,
      ];
      // 关闭弹框
      setTimeout(() => {
        this.$refs.carTypeSelector.hide();
      }, 1000);
    },
  }
};
</script>
<style lang="less" scoped>
.business-content-main {
  height: 100%;
  overflow: hidden;
}
.scroll-view {
  height: 99%;
  overflow-y: scroll;
}
.head {
  position: fixed;
  top: 81px;
  padding: 10px 10px 10px 10px;
  height: 110px;
  // width: 100%;
  width: 90%;
  background-color: white;
  z-index: 1;
  margin-left: -20px;
}
.qp-msg {
  p {
    padding-top: 10px;
  }
  .title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.qp-ctn {
  width: 100%;
  height: 100%;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  margin-top: 100px;
}

.qp-item {
  cursor: pointer;
  width: 250px;
  margin-right: 20px;
  margin-bottom: 20px;
  height: 389px;
}
.ops-ctn {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}
</style>
